export default class PDF {

    // Constructor
    constructor() {
		this.pdfKey = 'aa1faa83-85d7-4419-a282-e3b880aca1d8';
		this.pdfCode = 'uRAySbXyKm3CsRZSufEkTmuEdmaBj6Yec0G9tB4L4677OLdaDFXBpQ==';

        this.body = null;
        this.downloadButton = null;
    }

    // Init before frameworks
    init() {
        this.body = document.querySelector('body');
        this.downloadButton = document.querySelector('.tps-detail-body-buttons-button.download');

		if (this.downloadButton) {
			this.setEvent_downloadOnClick();
		}
    }

    // Init after frameworks
    initAfterFrameworks() { }

    // Destroy
    destroy() {
		if (this.downloadButton) {
			this.downloadButton.removeEventListener('click', this._downloadOnClick, true);
		}
    }

    // Set event: download PDF on button click
    setEvent_downloadOnClick() {
        this.downloadButton.addEventListener('click', this._downloadOnClick, true);
    }

    // Helper: download PDF on button click
    _downloadOnClick() {
		const self = window.tps.pdf; // this;
        const title = `${document.title}.pdf`;
		const debug = false;

		let url = document.location.href;
		url += (url.split('?')[1] ? '&': '?') + 'pdf=true';

		// https://docs.pdfshift.io/#general
		const props = {
			'source': url,
			'landscape': false,
			'use_print': false,
			'margin': '20px',
			'remove_blank': true,
			'sandbox': false,
			'format': 'Letter'
		};

        const postBody = {
            'FileName': title,
            'ResetCache': debug,
            'Properties': props
        };

		const postUrl = `https:\/\/tpspdf.pixelshopdesign.net/api/pdfs/${self.pdfKey}?code=${self.pdfCode}`;

        const settings = {
            'crossDomain': true,
            'url': postUrl,
            'method': 'POST',
            'headers': {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Cache-Control': 'no-cache'
            },
            'data': JSON.stringify(postBody)
		};

		self.body.classList.add('ajaxify-loading');

		jQuery.ajax(settings).done((result, textStatus, jqXHR) => {
			if (typeof textStatus === 'string' && textStatus === 'success') {
				document.location.href = result;
			} else {
				console.log('---- The PDF response was not an URL ----');
				console.log(result);
			}

			self.body.classList.remove('ajaxify-loading');
		});
	}

}
